import React from 'react'
import Footer from './Footer'

const Background = () => {
  return (
    <div className='fixed-bg'>
      <Footer />
    </div>
  )
}

export default Background